export const InsuranceOfferParametersGeneration = (offerData, selectedProviderId) => {
  const options = new URLSearchParams()
  options.append('id', offerData.id ?? '')
  options.append('organisation_id', selectedProviderId ?? '')
  options.append('product_type', offerData.product_type ?? '')
  options.append('name', offerData.name ?? '')
  options.append('zoho_id', offerData.zoho_id ?? '')
  options.append('zoho_package_id', offerData.zoho_package_id ?? '')
  options.append('active', offerData.active ?? '')
  options.append('insurance_commission', offerData.insurance_commission ?? '')
  options.append('display_fees', offerData.display_fees ?? '')
  options.append('description', offerData.description ?? '')
  options.append('usable_for_netting_process', offerData.usable_for_netting_process ?? 0)

  return options
}
